/**
 * Two cards in one column with nothing between them: "sama asia" is then a
 * straight line from one to the other. Anything else — a different column, or
 * cards in between that the line would cut through — takes the routed path.
 */
export function isStraightPair(fromId, toId, positions, nodes) {
  const a = positions[fromId]; const b = positions[toId];
  if (!a || !b || Math.abs(a.x - b.x) >= 1) return false;
  const lo = Math.min(a.y, b.y); const hi = Math.max(a.y, b.y);
  return !nodes.some((n) => {
    if (n.id === fromId || n.id === toId) return false;
    const p = positions[n.id];
    return p && Math.abs(p.x - a.x) < 1 && p.y > lo && p.y < hi;
  });
}

